import React, { FC, Fragment } from 'react';
import { useMatchMedia } from '../../hooks/useMatchMedia';
import Dummy from '../../../Dummy/Dummy';
import { isMobileChannel } from '../../../../common/util';
import { getSportIdByName } from '../../../../common/utils/utils';

export const MatchesLoadingPlaceholder: FC<{ count?: number; sportName?: string }> = ({ count = 10, sportName }) => {
    const matchMedia = useMatchMedia();
    const isMobileView = isMobileChannel();
    const sportId = getSportIdByName(sportName);
    return (
        <>
            {sportId && (
                <div
                    className={`bg-${sportId} ${
                        matchMedia.xxl || isMobileView ? 'sport-header-md' : 'sport-header-sm'
                    }`}
                />
            )}
            {Array.from({ length: count }).map((e, i) => (
                <Fragment key={`md${i}`}>
                    {isMobileView && (
                        <div className="bg-white-ng py-8 px-20 flex">
                            <div className="bg-black-5 br-radius-1em py-10 px-30" />
                        </div>
                    )}
                    <Dummy otherClass={`sport-overview-dummy${!isMobileView ? '-lg' : ' mb-8'} br-b-default-light`} />
                </Fragment>
            ))}
        </>
    );
};
